module.exports = __webpack_public_path__ + "assets/img/ground.c9f1afc0.png";